import styled, { css } from 'styled-components';

const Button = styled.button<{ disabled?: boolean }>`
  height: 54px;
  min-width: 200px;
  border-radius: 5px;
  background: #4069ed;
  color: #fff;
  border: none;
  cursor: pointer;

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.14px;
  text-transform: uppercase;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      cursor: default;
    `}
`;

export default { Button };
